import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
  DialogDescription,
} from "../../../Components/ui/PersonalInfoPopUpDialog";
import { Button } from "../../../Components/ui/button";
import { Switch } from "../../../Components/ui/switch";
import { useToast } from "../../../Components/ui/use-toast";
import { Select, SelectItem, SelectValue, SelectTrigger, SelectContent } from "../../../Components/ui/select"
import { Input } from "../../../Components/ui/input";

interface ViewAccountPopupProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  accountId: number;
  accountEmail: string;
  accountType: string;
}

interface Channel {
  channel_id: number;
  channel_name: string;
}

interface Operator {
  workspace_id: number;
  campaign_approval: boolean;
}

interface CheckedChannel {
  channelId: number;
  channelName: string;
}

const PersonalInfoPopup: React.FC<ViewAccountPopupProps> = ({
  isOpen,
  onOpenChange,
  accountId,
  accountEmail,
  accountType,
}) => {

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [workspaceType, setWorkspaceType] = useState<string>("");
  const [channelList, setChannelList] = useState<Channel[]>([]);
  const [channelToggles, setChannelToggles] = useState<{
    [key: number]: boolean;
  }>({});
  const [availableChannels, setAvailableChannels] = useState<Channel[]>([]);
  const [checkedChannels, setCheckedChannels] = useState<CheckedChannel[]>([]);
  const [existingcheckedChannels, setExistingCheckedChannels] = useState<
    CheckedChannel[]
  >([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [campaignApproval, setCampaignApproval] = useState<boolean>(false);
  const [minLimit, setMinLimit] = useState<string>("");
  const [maxLimit, setMaxLimit] = useState<string>("");
  const [deliveryWindowValue, setDeliveryWindowValue] = useState<string>("");
  const [deliveryWindowUnit, setDeliveryWindowUnit] = useState<string>("Minutes");
  const [initialCampaignApproval, setInitialCampaignApproval] = useState<boolean>(false);
  const [initialDeliveryWindowValue, setInitialDeliveryWindowValue] = useState<string>("");
  const [initialDeliveryWindowUnit, setInitialDeliveryWindowUnit] = useState<string>("Minutes");
  const [intervalError, setIntervalError] = useState<string>("");
  const [maxMessagesValue, setMaxMessagesValue] = useState<string>("");
const [initialMaxMessagesValue, setInitialMaxMessagesValue] = useState<string>("");
const [maxMessagesError, setMaxMessagesError] = useState<string>("");

  const toast = useToast();
  const apiUrlAdminAcc = useSelector(
    (state: RootState) => state.authentication.adminUrl
  );
  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL)

  const apiUrlOPeratorAcc = useSelector(
    (state: RootState) => state.authentication.operatorUrl)

  const CurrentAID = useSelector(
    (state: RootState) => state.authentication.account_id
  );

  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id
  );

    const userAccountId = useSelector(
    (state: RootState) => state.authentication.account_id
  );


  // useEffect(() => {
  //   if (!isOpen) return;

  //   if (checkedChannels.length > 0) {
  //     setChannelToggles((prev) => ({
  //       ...prev,
  //       ...Object.fromEntries(
  //         checkedChannels.map((channel) => [channel.channelId, true])
  //       ),
  //     }));
  //   }
  // }, [checkedChannels]);

  useEffect(() => {
    if (isOpen && apiUrlAdvAcc && apiUrlAdminAcc && accountEmail && apiUrlOPeratorAcc) {
      const fetchData = async () => {
        console.log("Fetching Data :");
        setIsLoading(true);
        try {
          await Promise.all([
            GetPersonalInfo(),
            GetTravellerCount(),
            GetChannelList(),
            GetCheckedChannelsList(),
            GetOperatorPermissions(),

          ]);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    } else {
      console.log("useEffect triggered. isOpen:", isOpen);
      console.log("Popup is closing, resetting state..."); // Debugging log
      setIntervalError("");
      setAvailableChannels([]);
      // setCheckedChannels([]);
      // setChannelToggles({});
      setFirstName("");
      setLastName("");
      setWorkspaceType("");
      setMaxMessagesValue("");
setInitialMaxMessagesValue("");
setMaxMessagesError("");
      // Restore pointer events after a short delay
      setTimeout(() => {
        document.body.style.pointerEvents = "";
      }, 500);
    }
    return;
  }, [isOpen]); // ✅ Only runs when `isOpen` changes

const UpdateMaxMessagesPerDay = async (maxMessages: number) => {
  try {
    const response = await axios.put(`${apiUrlAdminAcc}/UpdateMaxMessagesPerDay`, {
      accountId: accountId,
      maxMessages: maxMessages,
      userAccountId: Number(userAccountId),
      workspaceId: workspaceId
    });

    if (response.data?.status === "Success") {
      toast.toast({
        title: "Success",
        description: "Max messages per day updated successfully.",
      });
    } else {
      toast.toast({
        title: "Failed",
        description: "Failed to update max messages per day.",
      });
    }
  } catch (e) {
    console.error("Error updating max messages per day:", e);
    toast.toast({
      title: "Error",
      description: "Something went wrong. Please try again.",
    });
  }
};

  const UpdateWelcomeCampaignInterval = async (interval: number) => {
    try {
      const response = await axios.put(`${apiUrlAdminAcc}/UpdateWelcomeCampaignInterval`, {
        accountId: accountId,
        interval: interval,
        userAccountId : Number(userAccountId),
        workspaceId: workspaceId
      });

      if (response.data?.status === "Success") {
        toast.toast({
          title: "Success",
          description: "Welcome campaign interval updated successfully.",
        });
      } else {
        toast.toast({
          title: "Failed",
          description: "Failed to update welcome campaign interval.",
        });
      }
    } catch (e) {
      console.error("Error updating welcome campaign interval:", e);
      toast.toast({
        title: "Error",
        description: "Something went wrong. Please try again.",
      });
    }
  };

  const GetPersonalInfo = async () => {
    try {
      setIsLoading(true);
      console.log("Fetching Personal Info...");
      const response = await axios.post(
        `${apiUrlAdvAcc}/GetPersonalinfoByEmail`,
        {
          UserEmail: accountEmail,
        }
      );

      if (
        response.data.status === "Success" &&
        response.data.personalInfoList.length > 0
      ) {
        const user = response.data.personalInfoList[0];
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setWorkspaceType(user.workspace_type);
      } else {
        console.log("No personal info found for the given email.");
      }
    } catch (error) {
      console.error("Error fetching personal info:", error);
    }
  };

  const GetChannelList = async () => {
    try {
      setIsLoading(true);
      console.log("Fetching Channel List...");

      const response = await axios.get(`${apiUrlAdvAcc}/GetChannelList`);

      if (response.data?.channelList) {
        setChannelList(response.data.channelList);
        console.log("Channel List:", response.data.channelList);
      } else {
        console.log("No channel list available in response.");
        setChannelList([]); // ✅ Ensure empty list is set to prevent errors
      }
    } catch (error) {
      console.error("Error fetching channel list:", error);
    }
  };

  const GetCheckedChannelsList = async () => {
    try {
      setIsLoading(true);
      console.log("Fetching Checked Channels...");

      const response = await axios.get(
        `${apiUrlAdminAcc}/GetAdvertiserChannels?workspaceId=${accountId}`
      );

      if (
        response.data.status === "Success" &&
        Array.isArray(response.data.channels)
      ) {
        console.log("Checked Channels Response:", response.data.channels);
        setCheckedChannels(response.data.channels);
        setExistingCheckedChannels(response.data.channels);
      } else {
        console.log("Error fetching checked channels:", response);
        setCheckedChannels([]); // ✅ Prevent undefined errors
      }
    } catch (error) {
      console.error("Error fetching checked channels:", error);
      setCheckedChannels([]);
    }
  };


  const GetOperatorPermissions = async () => {
    try {
      const response = await axios.get(
        `${apiUrlOPeratorAcc}/GetOperatorPermissions?workspaceId=${accountId}`
      );

      if (
        response.data?.status === "Success" &&
        response.data?.campaignList?.length > 0
      ) {
        const data = response.data.campaignList[0];

        const approval = data.operator_campaign_approval;
        setCampaignApproval(approval);
        setInitialCampaignApproval(approval);

        const intervalValue = data.promo_msg_wait_time != null
          ? data.promo_msg_wait_time.toString()
          : "";
        setDeliveryWindowValue(intervalValue);
        setInitialDeliveryWindowValue(intervalValue);
        setDeliveryWindowUnit("Minutes");
        setInitialDeliveryWindowUnit("Minutes");


        const maxMessages = data.max_messages_per_day != null
  ? data.max_messages_per_day.toString()
  : "";
setMaxMessagesValue(maxMessages);
setInitialMaxMessagesValue(maxMessages);
      } else {
        console.warn("Failed to fetch campaign approval permission.");
      }
    } catch (error) {
      console.error("Error fetching operator permissions:", error);
    }
  };


  const handleDialogChange = (event: any) => {
    onOpenChange(event.target?.checked || false);
  };

  const handleToggle = (channel_id: number) => {
    console.log("Handle Toggle :", channel_id);

    setChannelToggles((prev) => {
      const updatedToggles = {
        ...prev,
        [channel_id]: !prev[channel_id], // ✅ Toggle the state correctly
      };

      // Update available channels based on the checked state
      const updatedAvailableChannels = Object.entries(updatedToggles)
        .filter(([_, isChecked]) => isChecked) // ✅ Only get checked channels
        .map(([id]) => channelList.find((c) => c.channel_id === Number(id))!)
        .filter(Boolean); // ✅ Remove undefined values

      console.log("Updated Channels :", updatedAvailableChannels);
      const updatedlist = updatedAvailableChannels.map((data) => ({
        channelId: data.channel_id,
        channelName: data.channel_name,
      }));

      console.log(updatedlist);
      setCheckedChannels(updatedlist);
      setAvailableChannels(updatedAvailableChannels);

      return updatedToggles;
    });
  };

  const sendNotification = async (channel: string) => {
    try {
      const payload = {
        workspaceId: accountId || 0,
        campaignId: 0,
        campaignName: "UnKnown",
        statusMark: "Unread",
        notificationType: "RequestGranted",
        notificationData: {
          Message: `${channel} Permisson Granted`,
        },
        role: "Advertiser",
      };
      console.log("payload :", payload);
      const response = await axios.post(
        `${apiUrlAdvAcc}/CreateNotification`,
        payload
      );

      if (response.data.status === "Success") {
        toast.toast({
          title: "Success",
          description: "Channels updated successfully.",
        });
      }
    } catch (e) {
      console.log("Error :", e);
      toast.toast({
        title: "Error Occurred",
        description: "An unexpected error occurred. Please try again later.",
      });
    }
  };

  // Function to save checked channels when clicking "Apply"

  // Function to save checked channels when clicking "Apply"
  // const handleApply = async () => {

  //   if (accountType === "Advertiser") {
  //     console.log("Saved Channels:", availableChannels);
  //     const Channels = availableChannels.map((data) =>
  //       data.channel_name.trim().toLowerCase()
  //     );
  //     console.log("Channels :", Channels);

  //     UpdateChannels(Channels);

  //     const oldchannels = existingcheckedChannels.map((data) =>
  //       data.channelName.trim().toLowerCase()
  //     );
  //     console.log("Old Channels:", oldchannels);

  //     const newlychangedchannels: string[] = Channels.filter(
  //       (data) => !oldchannels.includes(data)
  //     );

  //     console.log("Newly changed Channels:", newlychangedchannels);
  //     debugger;
  //     if (newlychangedchannels.length) {
  //       sendNotification(newlychangedchannels.toString());
  //     }
  //   } else if (accountType === "Telecom Operator") {

  //     // Validation
  //     if (deliveryWindowValue.trim() === "") {
  //       setIntervalError("Please enter a value for Welcome Campaign Interval.");
  //       return;
  //     }
  //     const parsedValue = Number(deliveryWindowValue);
  //     if (isNaN(parsedValue) || parsedValue <= 0) {
  //       setIntervalError("Please enter a valid number greater than 0.");
  //       return;
  //     }
  //     setIntervalError("");

  //     const approvalChanged = campaignApproval !== initialCampaignApproval;
  //     const intervalChanged =
  //       deliveryWindowValue !== initialDeliveryWindowValue ||
  //       deliveryWindowUnit !== initialDeliveryWindowUnit;

  //     if (approvalChanged) {
  //       await UpdateOperatorPermissions(campaignApproval);
  //     }

  //     if (intervalChanged) {
  //       const intervalInMinutes =
  //         deliveryWindowUnit === "Hours"
  //           ? parsedValue * 60
  //           : parsedValue;
  //       await UpdateWelcomeCampaignInterval(intervalInMinutes);
  //     }

  //     if (!approvalChanged && !intervalChanged) {
  //       toast.toast({
  //         title: "No Changes Detected",
  //         description: "No modifications were made to the operator settings.",
  //       });
  //     }

  //     onOpenChange(false);
  //   }
  //   else if (accountType === "Personal" && workspaceType === "Advertiser") {
  //     try {
  //       const response = await axios.post(`${apiUrlAdminAcc}/InsertTravellerCount`, {
  //         emailId: accountEmail,
  //         min: parseInt(minLimit),
  //         max: parseInt(maxLimit),
  //         workspaceId: workspaceId,
  //         currentAID: CurrentAID,
  //         accountId: accountId
  //       });

  //       if (response.data.status === "Success") {
  //         toast.toast({
  //           title: "Success",
  //           description: "Traveller count added successfully.",
  //         });
  //         onOpenChange(false);
  //       } else {
  //         toast.toast({
  //           title: "Failed",
  //           description: response.data.Status_Description || "Update failed.",
  //         });
  //       }
  //     } catch (error) {
  //       toast.toast({
  //         title: "Error",
  //         description: "Something went wrong while saving traveller count.",
  //       });
  //       console.error(error);
  //     }
  //   }

  // };

  const handleApply = async () => {

    if (accountType === "Advertiser") {
      console.log("Saved Channels:", availableChannels);
      const Channels = availableChannels.map((data) =>
        data.channel_name.trim().toLowerCase()
      );
      console.log("Channels :", Channels);

      UpdateChannels(Channels);

      const oldchannels = existingcheckedChannels.map((data) =>
        data.channelName.trim().toLowerCase()
      );
      console.log("Old Channels:", oldchannels);

      const newlychangedchannels: string[] = Channels.filter(
        (data) => !oldchannels.includes(data)
      );

      console.log("Newly changed Channels:", newlychangedchannels);
      debugger;
      if (newlychangedchannels.length) {
        sendNotification(newlychangedchannels.toString());
      }
    } else if (accountType === "Telecom Operator") {

      // Validation
      if (deliveryWindowValue.trim() === "") {
        setIntervalError("Please enter a value for Welcome Campaign Interval.");
        return;
      }
      const parsedValue = Number(deliveryWindowValue);
      if (isNaN(parsedValue) || parsedValue <= 0) {
        setIntervalError("Please enter a valid number greater than 0.");
        return;
      }
      setIntervalError("");

      if (maxMessagesValue.trim() === "") {
        setMaxMessagesError("Please enter a value for Maximum Messages Per Day.");
        return;
      }
      const parsedMaxMessages = Number(maxMessagesValue);
      if (isNaN(parsedMaxMessages) || parsedMaxMessages <= 0) {
        setMaxMessagesError("Please enter a valid number greater than 0.");
        return;
      }
      setMaxMessagesError("");

      const approvalChanged = campaignApproval !== initialCampaignApproval;
      const intervalChanged =
        deliveryWindowValue !== initialDeliveryWindowValue ||
        deliveryWindowUnit !== initialDeliveryWindowUnit;
      const maxMessagesChanged = maxMessagesValue !== initialMaxMessagesValue;

      if (approvalChanged) {
        await UpdateOperatorPermissions(campaignApproval);
      }

      if (intervalChanged) {
        const intervalInMinutes =
          deliveryWindowUnit === "Hours"
            ? parsedValue * 60
            : parsedValue;
        await UpdateWelcomeCampaignInterval(intervalInMinutes);
      }

      if (maxMessagesChanged) {
        await UpdateMaxMessagesPerDay(parsedMaxMessages);
      }

      if (!approvalChanged && !intervalChanged && !maxMessagesChanged) {
        toast.toast({
          title: "No Changes Detected",
          description: "No modifications were made to the operator settings.",
        });
      }

      onOpenChange(false);
    }
    else if (accountType === "Personal" && workspaceType === "Advertiser") {
      try {
        const response = await axios.post(`${apiUrlAdminAcc}/InsertTravellerCount`, {
          emailId: accountEmail,
          min: parseInt(minLimit),
          max: parseInt(maxLimit),
          workspaceId: workspaceId,
          currentAID: CurrentAID,
          accountId: accountId
        });

        if (response.data.status === "Success") {
          toast.toast({
            title: "Success",
            description: "Traveller count added successfully.",
          });
          onOpenChange(false);
        } else {
          toast.toast({
            title: "Failed",
            description: response.data.Status_Description || "Update failed.",
          });
        }
      } catch (error) {
        toast.toast({
          title: "Error",
          description: "Something went wrong while saving traveller count.",
        });
        console.error(error);
      }
    }

  };

  const GetTravellerCount = async () => {
    try {
      const res = await axios.get(`${apiUrlAdminAcc}/GetTravellerCount`, {
        params: { emailId: accountEmail },
      });

      if (res.data.status === "Success" && res.data.travellerCount) {
        const { min, max } = res.data.travellerCount; // ✅ lowercase
        setMinLimit(min.toString());
        setMaxLimit(max.toString());
      } else {
        console.log("No traveller count set yet.");
        setMinLimit("");
        setMaxLimit("");
      }
    } catch (err) {
      console.error("Failed to fetch traveller count:", err);
      setMinLimit("");
      setMaxLimit("");
    }
  };



  const UpdateChannels = async (ChannelsData: string[]) => {
    try {
      setIsSubmitting(true);
      const response = await axios.post(
        `${apiUrlAdminAcc}/InsertAdvertiserChannels`,
        {
          WorkspaceId: accountId,
          Channels: ChannelsData,
        }
      );
      if (response.data.status === "Success") {
        toast.toast({
          title: "Success",
          description: "Channels updated successfully.",
        });
        setIsSubmitting(false);
      } else {
        toast.toast({
          title: "Failed",
          description: "Failed to update.",
        });
        setIsSubmitting(false);
      }
    } catch (e) {
      console.log("Error :", e);
      toast.toast({
        title: "Error",
        description: "Something went wrong, Please try again",
      });
      setIsSubmitting(false);
    } finally {
      onOpenChange(false);
    }
  };

  const UpdateOperatorPermissions = async (approval: boolean) => {
    try {
      setIsSubmitting(true);
      const response = await axios.put(`${apiUrlOPeratorAcc}/UpdateOperatorPermissions`, {
        workspaceId: accountId,//workspaceId is passed in the name of accountId
        campaignApproval: approval,
        currentAID: CurrentAID,
        accountId: workspaceId,//accountId is passed in the name of workspaceId
      });

      if (response.data?.status === "Success") {
        toast.toast({
          title: "Success",
          description: "Auto Approval updated successfully.",
        });
      } else {
        toast.toast({
          title: "Failed",
          description: "Failed to Auto Approval permissions.",
        });
      }
    } catch (e) {
      console.error("Error updating permissions:", e);
      toast.toast({
        title: "Error",
        description: "Something went wrong. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };


    return (
    <Dialog open={isOpen} onOpenChange={handleDialogChange}>
      <DialogContent className="w-full max-w-xl max-h-screen">
        <DialogHeader className="flex items-center mt-2">
          <DialogTitle>Account Details</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col flex-grow gap-2">
          <div className="ml-4 flex flex-col flex-grow gap-2 m-2">
            <div className="flex flex-row ">
              <div className="basis-1/2 text-[14px] font-medium text-[#020617]">
                Account ID
              </div>
              <div className="basis-1/2  text-[14px] font-normal">
                : {accountId}
              </div>
            </div>

            <div className="flex flex-row flex-grow  w-auto">
              <div className="basis-1/2 shrink-0 text-[14px] font-medium text-[#020617]">
                Account Email
              </div>
              <div className="basis-1/2 flex-grow text-[14px] font-normal break-all">
                : {accountEmail}
              </div>
            </div>

            <div className="flex flex-row">
              <div className="basis-1/2 text-[14px] font-medium text-[#020617]">
                First Name
              </div>
              <div className="basis-1/2 text-[14px] font-normal">
                : {firstName || "Loading..."}
              </div>
            </div>
            <div className="flex flex-row">
              <div className="basis-1/2 text-[14px] font-medium text-[#020617]">
                Last Name
              </div>
              <div className="basis-1/2 text-[14px] font-normal">
                : {lastName || "Loading..."}
              </div>
            </div>

            <div className="flex flex-row">
              <div className="basis-1/2 text-[14px] font-medium text-[#020617]">
                Workspace Type
              </div>
              <div className="basis-1/2 text-[14px] font-normal">
                : {workspaceType || "Loading..."}
              </div>
            </div>
          </div>

          {accountType === "Personal" && workspaceType === "Advertiser" && (
            <div className=" flex flex-col gap-4 rounded-md p-4 ">
              <div className="flex flex-col gap-2">
                <label className="text-[14px] font-medium text-[#020617]">
                  Minimum Traveller Count per Country
                </label>
                <input
                  type="number"
                  value={minLimit}
                  onChange={(e) => setMinLimit(e.target.value)}
                  placeholder="Enter minimum count"
                  className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[14px] font-medium text-[#020617]">
                  Maximum Traveller Count per Country
                </label>
                <input
                  type="number"
                  value={maxLimit}
                  onChange={(e) => setMaxLimit(e.target.value)}
                  placeholder="Enter maximum count"
                  className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>
            </div>
          )}

          {accountType === "Telecom Operator" ? (
            <div className="flex flex-col gap-3 p-4 border rounded-lg shadow-lg w-full">
              {isLoading && checkedChannels.length === 0 ? (
                <div className="flex justify-between items-center p-3">
                  <span className="text-[14px] font-medium text-[#020617]">Loading...</span>
                </div>
              ) : (
                <>
                  {/* Auto Approval */}
                  <div className="flex justify-between items-center bg-gray-50 p-3 rounded-lg">
                    <span className="text-[14px] font-medium text-[#020617]">Auto Approval</span>
                    <Switch
                      checked={campaignApproval ?? false}
                      onCheckedChange={(value) => setCampaignApproval(value)}
                    />
                  </div>

                  {/* Welcome Campaign Interval */}
                  <div className="flex flex-col gap-2 bg-gray-50 p-3 rounded-lg">
                    <span className="text-[14px] font-medium text-[#020617]">Welcome Campaign Interval</span>
                    <div className="flex gap-2">
                      <Input
                        type="text"
                        placeholder="0"
                        value={deliveryWindowValue}
                        onChange={(e) => {
                          setDeliveryWindowValue(e.target.value);
                          setIntervalError("");
                        }}
                        className={`flex-1 text-[#020617] ${intervalError ? "border-red-500 focus-visible:ring-red-500" : ""}`}
                      />
                      <Select value={deliveryWindowUnit} onValueChange={(value) => setDeliveryWindowUnit(value)}>
                        <SelectTrigger className="flex-1">
                          <SelectValue placeholder="Unit" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Minutes">Minutes</SelectItem>
                          <SelectItem value="Hours">Hours</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    {intervalError && (
                      <span className="text-[12px] text-red-500">{intervalError}</span>
                    )}
                  </div>

                  {/* Maximum Messages Per Day */}
                  <div className="flex flex-col gap-2 bg-gray-50 p-3 rounded-lg">
                    <span className="text-[14px] font-medium text-[#020617]">Maximum Messages Per Day</span>
                    <Input
                      type="text"
                      placeholder="0"
                      value={maxMessagesValue}
                      onChange={(e) => {
                        setMaxMessagesValue(e.target.value);
                        setMaxMessagesError("");
                      }}
                      className={`flex-1 text-[#020617] ${maxMessagesError ? "border-red-500 focus-visible:ring-red-500" : ""}`}
                    />
                    {maxMessagesError && (
                      <span className="text-[12px] text-red-500">{maxMessagesError}</span>
                    )}
                  </div>
                </>
              )}
            </div>
          ) : null}

          <div className="flex justify-center flex-wrap">
            {(accountType === "Telecom Operator" ||
              (accountType === "Personal" && workspaceType === "Advertiser")) ? (
              <Button
                className="mb-2 py-1 w-full bg-[#3A85F7] text-[14px] font-medium text-[#FAFAFA]"
                onClick={handleApply}
                disabled={isSubmitting}
              >
                Apply
              </Button>
            ) : (
              <Button
                className="mb-2 py-1 w-full bg-[#3A85F7] text-[14px] font-medium text-[#FAFAFA]"
                onClick={() => onOpenChange(false)}
              >
                Close
              </Button>
            )}
          </div>

        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PersonalInfoPopup;